import { Link } from 'gatsby';
import * as React from 'react';

import { styled } from '@mui/material/styles';
import { Typography, Breadcrumbs } from '@mui/material';

function handleClick(event) {
  event.preventDefault();
}

const StyledLink = styled(Link)({
  fontSize: '13px',
  lineHeight: '14px',
  letterSpacing: '0.01em',
  textTransform: 'uppercase',
  color: '#F4F5F7',
  opacity: 0.5,
});

const StyledLinkActive = styled(StyledLink)({
  color: '#D1D1D1',
  opacity: 1,
});

export default function Breadcrumb(props) {
  return (
    <div role="presentation" onClick={handleClick} style={{ width: '100%' }}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledLink to="/timeline-details/TheReformation">{props.seasonName || 'Reformation'}</StyledLink>
        <StyledLinkActive to={props.path} aria-current="page">
          {props.pageContext.peopleName}
        </StyledLinkActive>
      </Breadcrumbs>
    </div>
  );
}
